import { render } from "./HorizontalItemScrollWindow.vue?vue&type=template&id=6f8b96f8&scoped=true"
import script from "./HorizontalItemScrollWindow.vue?vue&type=script&lang=js"
export * from "./HorizontalItemScrollWindow.vue?vue&type=script&lang=js"

import "./HorizontalItemScrollWindow.vue?vue&type=style&index=0&id=6f8b96f8&scoped=true&lang=css"

import exportComponent from "/Users/user/Development/spin-demo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f8b96f8"]])

export default __exports__